import { ClientService, RequestMethod } from "../client-service";
import { RequestResponseLogic } from "../Ui/request-response";

const ATTACHMENT = "/document/attachment";

export const AttachmentLogic = {
  async downloadAttachment(attachmentId, params) {
    let result = await ClientService.sendRequest(
      RequestMethod.GET,
      ATTACHMENT + "/" + attachmentId,
      params
    );
    const responseBody = await RequestResponseLogic.checkRequestResponse(
      result,
      false
    );
    return responseBody.Data ? responseBody.Data : responseBody;
  },
  async uploadAttachment(file, typeName, entityId, params) {
    let result = await ClientService.sendRequestWithFile(
      RequestMethod.POST,
      ATTACHMENT + "/" + typeName + "/" + entityId,
      params,
      file
    );
    return await RequestResponseLogic.checkRequestResponse(result);
  },
  async deleteAttachment(attachmentId, params) {
    let result = await ClientService.sendRequest(
      RequestMethod.DELETE,
      ATTACHMENT + "/" + attachmentId,
      params
    );
    return await RequestResponseLogic.checkRequestResponse(result);
  },
};
